'use strict';
require('../modules/web.url-search-params');
require('../modules/web.url-search-params.delete');
require('../modules/web.url-search-params.has');
require('../modules/web.url-search-params.size');
var path = require('../internals/path');

module.exports = path.URLSearchParams;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/web/url-search-params.js
// module id = 497
// module chunks = 0